// Writer for the cross-subdomain "is this browser signed in?" flag.
//
// Only ever imported from the studio graph (authApi), so it may safely depend on
// host routing. The matching reader lives in authPresence.js and is bundled into
// the demo surface. The two files deliberately share no module – that isolation
// is what keeps Supabase out of the demo bundle – so the cookie name is
// duplicated in both and the two literals must stay in sync.
import { getSharedCookieDomain } from '@/lib/hostRouting'

const AUTH_PRESENCE_COOKIE = 'retira_authed'

// Refreshed on every studio visit and cleared on sign-out, so this only goes
// stale if a refresh token silently expires between visits. A stale flag at
// worst shows the demo banner once; clicking through to studio then resolves it
// (the auth gate redirects to login). Kept long enough to survive normal use.
const MAX_AGE_SECONDS = 30 * 24 * 60 * 60

function buildCookieAttributes() {
  const domain = getSharedCookieDomain()
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  const domainAttr = domain ? `; Domain=${domain}` : ''
  return `Path=/; SameSite=Lax${domainAttr}${secure}`
}

// Records whether a Supabase session currently exists. Called from the studio
// surface whenever the session changes (sign-in, refresh, sign-out).
export function setAuthPresence(isAuthenticated) {
  if (typeof document === 'undefined') return

  const attributes = buildCookieAttributes()

  if (isAuthenticated) {
    document.cookie = `${AUTH_PRESENCE_COOKIE}=1; Max-Age=${MAX_AGE_SECONDS}; ${attributes}`
  } else {
    document.cookie = `${AUTH_PRESENCE_COOKIE}=; Max-Age=0; ${attributes}`
  }
}
